export const CHANGE_DONE = "CHANGE_DONE";



export const changeDoneAction = () => ({
  type: CHANGE_DONE,

});